/* eslint-disable better-mutation/no-mutation */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Category } from 'tradera/state/services/touchweb-syi-api';

type CategoryState = {
    draftCategoryId?: number;
    draftCategoryPath: Category[];
    validationError: string | null;
};

const initialState: CategoryState = {
    draftCategoryId: 0,
    draftCategoryPath: [],
    validationError: null,
};

function validate(state: CategoryState) {
    if (!state.draftCategoryId || state.draftCategoryId === 0) {
        state.validationError = 'syi_validation_missing_category';
    } else {
        state.validationError = null;
    }
}

const categorySlice = createSlice({
    name: 'category',
    initialState,
    reducers: {
        resetCategory: (state) => {
            state.draftCategoryId = 0;
            state.draftCategoryPath = [];
            validate(state);
        },
        setDraftCategory: (
            state,
            action: PayloadAction<{
                categoryId: number;
                categoryPath: Category[];
            }>,
        ) => {
            state.draftCategoryId = action.payload.categoryId;
            state.draftCategoryPath = action.payload.categoryPath;
            validate(state);
        },
    },
});

export const { resetCategory, setDraftCategory } = categorySlice.actions;

export default categorySlice.reducer;
